$(function () {
  var KEY = 'popup_visited_session';
  var $modal = $('[data-modal]');

  if (!sessionStorage.getItem(KEY)) {
    $modal.addClass('visited');
    sessionStorage.setItem(KEY, '1');
  }

  // ×ボタン
  $('[data-modal-close]').on('click', function (e) {
    e.preventDefault();
    $modal.removeClass('visited');
  });

  // モーダル背景部分だけをクリックした時
  $('[data-modal]').on('click', function (e) {
    // 背景そのものをクリックした場合だけ閉じる
    if (e.target === this) {
      $modal.removeClass('visited');
    }
  });
});